import { Grid, MenuItem, Paper, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { ProjectRegisterModel } from "../Data/ProjectRegisterModel";
import { generateTableColumn } from "pages/Dashboards/ProjectRegister/data/metricsUtils";
import CustomDataGrid from "./CustomDataGrid";
import { Constants } from "constants/constant";

const ProjectRegisterTable: React.FC<{
  projectRegisterModel: ProjectRegisterModel[];
  currency: string;
}> = ({ projectRegisterModel,currency  }) => {
  const [rows, setRows] = useState<ProjectRegisterModel[]>([]);
  const UNIT_TCO2E=Constants.UNIT_TCO2E;

  useEffect(() => {
    setRows(projectRegisterModel);
  }, [projectRegisterModel]);

  const columns = [
    {
      field: "rowId",
      headerClassName: "table-header",
      headerName: "#S.No",
      minWidth: 40,
    },
    {
      field: "locationName",
      headerClassName: "table-header",
      headerName: "Location Name",
      minWidth: 190,
    },
    {
      field: "scenarios",
      headerClassName: "table-header",
      headerName: "Plans",
      minWidth: 190,
      flex: 1,
      renderCell: (params: any) => (
        <Select
          value={params.row.scenarioSection}
          fullWidth
          onChange={() => {}}
        >
          {params.value.map((scenario: string, index: number) => (
            <MenuItem key={index+1} value={scenario}>
              {scenario}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    generateTableColumn("emissionReduction", `Emissions Reduction (${UNIT_TCO2E})`, 208),
    generateTableColumn("roi", "ROI (%)", 208),
    generateTableColumn("annualNPV", `Annual NPV (${currency})`, 100),
    generateTableColumn("mac", `MAC(${currency}/${UNIT_TCO2E})`, 140),
    generateTableColumn("capExInvestment", `CapEx Investment (${currency})`, 140),
    generateTableColumn("opEx", `OPEX (${currency})`, 140),
    
  ];

  return (
    <Grid item xs={12} sx={{ mb: 1, width: '100%', maxWidth: '100%' }}>
      <Paper variant="outlined" sx={{ width: '100%', overflow: 'hidden' }}>
        <Grid item sx={{ ml: 1, mt: 1, mb: 4 }}>
          <div
            style={{
              fontFamily: "Inter",
              fontSize: "18px",
              fontWeight: "600",
              color: "#05004E",
              width: "100%",
              marginLeft: "8px",
            }}
          >
            Project Register
          </div>
        </Grid>
        <Grid item>
            <CustomDataGrid rows={rows} columns={columns} getRowId={(row) => row?.locationName} />
        </Grid>
      </Paper>
    </Grid>
  );
};

export default ProjectRegisterTable;
